// Step 1 (FR-W4/W5 entry): labeled, camera-capable file input. Normalization
// and the soft location prompt happen in the store once a file is picked.
import { useId } from 'react';

interface PhotoPickStepProps {
  onPick: (file: File) => void;
  restartNotice: string | null;
}

export function PhotoPickStep({ onPick, restartNotice }: PhotoPickStepProps): React.JSX.Element {
  const inputId = useId();
  return (
    <div className="flex flex-col items-center gap-4 py-8 text-center">
      {restartNotice && (
        <p className="rounded-xl bg-secondary px-4 py-2 text-sm text-secondary-foreground">{restartNotice}</p>
      )}
      <p className="text-sm text-muted-foreground max-w-sm">
        Snap a business card, truck, storefront, or screenshot — we&rsquo;ll pull out the details.
        If you allow location, we&rsquo;ll remember where you snapped it.
      </p>
      <label
        htmlFor={inputId}
        className="cursor-pointer rounded-full bg-primary px-6 py-3 font-semibold text-primary-foreground transition-colors hover:bg-[var(--stash-blue-dark)]"
      >
        📸 Choose or take a photo
        <span className="sr-only">photo</span>
      </label>
      <input
        id={inputId}
        type="file"
        accept="image/*"
        capture="environment"
        className="sr-only"
        aria-label="photo"
        onChange={(event) => {
          const file = event.target.files?.[0];
          if (file) onPick(file);
        }}
      />
    </div>
  );
}
